import MicroModal from 'micromodal'

const cmpPopupModal = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

    MicroModal.init({
      onShow: modal => console.info(`${modal.id} is shown`),
      onClose: modal => console.info(`${modal.id} is hidden`),
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: false
    })

    const button = _.component.querySelectorAll('.modal-button')
    for (let i = 0; i < button.length; i++) {
      button[i].addEventListener('click', function () {
        MicroModal.show(button[i].id)
      })
    }
  }
}

export default cmpPopupModal
